import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { submitUrl: String };

  intercept(event) {
    event.preventDefault();
    event.stopPropagation();

    // Primer::Alpha::Dialog hoists the <dialog> to <body>, so we need to
    // find elements by ID/selector rather than using Stimulus targets.
    // Wait for dialog to open before wiring up scroll + checkbox logic.
    requestAnimationFrame(() => {
      const dialog = document.getElementById("terms-acceptance-dialog");
      if (!dialog) return;

      this.checkbox = dialog.querySelector("[data-terms-checkbox]");
      this.confirmBtn = dialog.querySelector("[data-terms-confirm]");
      this.termsBody = dialog.querySelector("[data-terms-body]");

      // Reset state
      if (this.checkbox) {
        this.checkbox.checked = false;
        this.checkbox.disabled = true;
      }
      if (this.confirmBtn) this.confirmBtn.disabled = true;

      // Wire up scroll listener
      if (this.termsBody) {
        this.termsBody.addEventListener("scroll", this._onScroll);
        // Check if content doesn't overflow (no scroll needed)
        this._checkScroll();
      }

      // Wire up checkbox listener
      if (this.checkbox) {
        this.checkbox.addEventListener("change", this._onCheckbox);
      }

      // Wire up confirm listener
      if (this.confirmBtn) {
        this.confirmBtn.addEventListener("click", this._onConfirm);
      }
    });
  }

  _onScroll = () => this._checkScroll();

  _checkScroll() {
    if (!this.termsBody) return;
    const remaining =
      this.termsBody.scrollHeight -
      this.termsBody.scrollTop -
      this.termsBody.clientHeight;

    if (remaining < 20 && this.checkbox) {
      this.checkbox.disabled = false;
    }
  }

  _onCheckbox = () => {
    if (this.confirmBtn && this.checkbox) {
      this.confirmBtn.disabled = !this.checkbox.checked;
    }
  };

  _onConfirm = () => {
    // Close the Primer dialog
    const dialog = document.getElementById("terms-acceptance-dialog");
    if (dialog) {
      const dialogEl = dialog.closest("dialog") || dialog.querySelector("dialog") || dialog;
      if (dialogEl.close) dialogEl.close();
    }

    // Build and submit a POST form
    const form = document.createElement("form");
    form.method = "POST";
    form.action = this.submitUrlValue;

    // CSRF token
    const csrfToken = document.querySelector(
      "meta[name='csrf-token']"
    )?.content;
    if (csrfToken) {
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }

    // Terms accepted param
    const termsInput = document.createElement("input");
    termsInput.type = "hidden";
    termsInput.name = "terms_accepted";
    termsInput.value = "1";
    form.appendChild(termsInput);

    document.body.appendChild(form);
    form.submit();
  };
}
